import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import IntegrationContent from "./IntegrationContent";

const Integrations = ({ state, dispatch }) => {
	const { t } = useTranslation();
	const { appId } = useParams();
	const [is404, setIs404] = useState(false);

	if (is404 === false) {
		return (
			<>
				<IntegrationContent
					id={appId}
					setIs404={setIs404}
					state={state}
					dispatch={dispatch}
				/>
			</>
		);
	} else {
		return <p>{t("message.applicationIdNotExist", { appId })}</p>;
	}
};

export default Integrations;
